export default {
  items: [
    
    /* {
      lang_key: 'map',
      name: 'Mapa',
      url:  '/map',
      icon: 'icon-map',
    }, */
    {
      lang_key: 'orders',
      name: 'Órdenes',
      url:  '/order-management',
      icon: 'icon-bag',
    },
    /*
    {
      lang_key: 'dashboard',
      name: 'Dashboard',
      url:  '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      lang_key: 'billing',
      name: 'Mis cobros',
      //url:  '/company-billings',
      url:  '/company-charges',
      icon: 'icon-wallet',
    },
    {
      lang_key: 'categories',
      name: 'Categorías',
      url:  '/categories-management',
      icon: 'icon-list'
    },
    
    {
      lang_key: 'goods',
      name: 'Productos',
      url:  '/goods-management',
      icon: 'icon-book-open',
    },*/
    {
      lang_key: '',
      name: 'Finanzas',
      icon: 'icon-wallet',
      children: [
        {
          lang_key: 'billing',
          name: 'Mis cobros',
          url:  '/company-charges'
        },
        {
          lang_key: 'reports',
          name: 'Reportes',
          url:  '/reports',
        },
      ]
    },
  ],
};



// WEBPACK FOOTER //
// ./src/_nav_es.js